import React from 'react';
import { PropTypes } from 'prop-types';
// style
import styled, { css } from 'styled-components';
import { media, zIndexses } from 'utils/style';
// components
import MainMenuMulticolorLogo from 'refactored/ui/nav/mainMenu/MainMenuMultiColorLogo';
import MainMenuEntries from 'refactored/ui/nav/mainMenu/MainMenuEntries';
import MainMenuCollapseButton from 'refactored/ui/nav/mainMenu/MainMenuCollapseButton';
import MainMenuNewsButton from './MainMenuNewsButton';
import MainMenuSeparator from './MainMenuSeparator';
import { SERVICES } from 'tenant/utils';

export const MAIN_MENU_WIDTH = '344px';
export const MAIN_MENU_COLLAPSED_WIDTH = '80px';

const MainMenuBottomButtonsContainer = styled.div`
  margin-top: auto;
  ${MainMenuSeparator} {
    max-width: ${MAIN_MENU_COLLAPSED_WIDTH};
  }
`;

const MainMenuBar = ({ className, handleBack, isCollapsed }) => {
  return (
    <div className={className}>
      <MainMenuMulticolorLogo
        handleBack={handleBack}
        showMulticolor={isCollapsed}
      />
      <MainMenuEntries isCollapsed={isCollapsed} />

      <MainMenuBottomButtonsContainer>
        {/* this button is to open beamer*/}
        {SERVICES.BEAMER && <MainMenuNewsButton isCollapsed={isCollapsed} />}
        <MainMenuCollapseButton isCollapsed={isCollapsed} />
      </MainMenuBottomButtonsContainer>
    </div>
  );
};

MainMenuBar.propTypes = {
  handleBack: PropTypes.func,
  isCollapsed: PropTypes.bool,
  className: PropTypes.string,
};

const regularCSS = css`
  background-color: var(--primary500);
  position: absolute;
  top: 0;
  height: 100%;
  z-index: ${zIndexses.mainMenuBar};
  display: flex;
  flex-direction: column;
  width: ${MAIN_MENU_WIDTH};
  transition: width 0.3s ease;
`;

const tabletCSS = css`
  ${(props) =>
    props.isCollapsed &&
    css`
      width: ${MAIN_MENU_COLLAPSED_WIDTH};
    `}
`;

const mobileCSS = css`
  display: none;
  width: 0;
  overflow: hidden;
`;

export default styled(MainMenuBar)`
  ${regularCSS};
  ${media.lessThan('huge')`${tabletCSS}`};
  ${media.lessThan('small')`${mobileCSS}`}
`;
